/* ============
 * Recipe Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class RecipeIngredienceTransformer extends Transformer {

  static fetch(recipeIngredience) {
    return {
      id: recipeIngredience.id,
      recipeId: recipeIngredience.recipe_id,
      recipe: recipeIngredience.recipe,
      materialId: recipeIngredience.material_id,
      materialName: recipeIngredience.material_name,
      materialType: recipeIngredience.material_type,
      unitMeasure: recipeIngredience.unit_measure,
      amount: recipeIngredience.amount,
    };
  }

  static send(recipeIngredience) {
    return {
      id: recipeIngredience.id,
      recipe_id: recipeIngredience.recipeId,
      material_id: recipeIngredience.materialId,
      amount: recipeIngredience.amount,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/recipeIngredience.js